// @need-translate
import {TextTKey} from '../../../common/type';
import {InternalStaticImageType} from '../../../design-system/atoms/StaticImage/InternalStaticImageType.enum';
import {ShortcutHomeType} from '../../../graphql/generated/types';

export const SHORTCUT_HOME_ICON_MAP: {
  [key in ShortcutHomeType]: InternalStaticImageType;
} = {
  [ShortcutHomeType.Taste]: InternalStaticImageType.ShortcutHome,
  [ShortcutHomeType.Webtoon]: InternalStaticImageType.ShortcutWebtoon,
  [ShortcutHomeType.WebNovel]: InternalStaticImageType.ShortcutWebNovel,
  [ShortcutHomeType.Book]: InternalStaticImageType.ShortcutBook,
};

// TODO : 디자인 시스템에 색상 추가 요청
export const SHORTCUT_COLOR_MAP: {[key in ShortcutHomeType]: string} = {
  [ShortcutHomeType.Taste]: '#212B96',
  [ShortcutHomeType.Webtoon]: '#FFE500',
  [ShortcutHomeType.WebNovel]: '#009266',
  [ShortcutHomeType.Book]: '#5F20E6',
};

export const SHORTCUT_TEXT_MAP: {[key in ShortcutHomeType]: TextTKey} = {
  [ShortcutHomeType.Taste]: {
    text: '추천',
    textTKey: 'screen_direct_recommend',
  },
  [ShortcutHomeType.Webtoon]: {
    text: '웹툰',
    textTKey: 'screen_direct_webtoon',
  },
  [ShortcutHomeType.WebNovel]: {
    text: '웹소설',
    textTKey: 'screen_direct_novel',
  },
  [ShortcutHomeType.Book]: {
    text: '책',
    textTKey: 'screen_direct_book',
  },
};
